import React from 'react'
import WMSLayer from '../Leaflet/WMSLayer'

export default () => (
	<WMSLayer
		url = "/maps/topowebb/wms/v1?"
		layers = "topowebbkartan"
	/>
)


// WEBPACK FOOTER //
// ./src/components/Map/TopowebbWMSLayer.js